module.exports = __webpack_public_path__ + "img/about6.d94a107f.jpg";